"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { ShieldCheck, ShieldAlert, Network, Puzzle, MonitorCog, Boxes, ChartLine, BrainCircuit, MessageSquareText, Headset } from "lucide-react";
export default function ResumenServicios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}